// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '',
  ROOT: '/',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  // PUBLIC CERTIFICATE
  certificate: {
    view: (projectId) => `/certificate/${projectId}`,
    root: '/certificate',
  },
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    forgetPassword: `${ROOTS.AUTH}/forget-password`,
    resetNewPassword: `${ROOTS.AUTH}/reset-new-password`,
    initiatePassword: `${ROOTS.AUTH}/initiate-password`,
    fairSignUp: `${ROOTS.AUTH}/fair-signup`,
    judgeSignUp: `${ROOTS.AUTH}/judge-signup`,
    generalUserSignUp: `${ROOTS.AUTH}/general-user-signup`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.ROOT,
    home: {
      projectConsent: (id) => `${ROOTS.DASHBOARD}/home/project-consent/${id}`,
    },
    // Accommodation
    accommodation: {
      root: `${ROOTS.DASHBOARD}/accommodation`,
      hotel: {
        root: `${ROOTS.DASHBOARD}/accommodation/hotel`,
        new: `${ROOTS.DASHBOARD}/accommodation/hotel/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/accommodation/hotel/edit/${id}`,
      },
      room: {
        root: `${ROOTS.DASHBOARD}/accommodation/room`,
        new: `${ROOTS.DASHBOARD}/accommodation/room/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/accommodation/room/edit/${id}`,
      },
    },
    // Define
    define: {
      root: `${ROOTS.DASHBOARD}/define`,
      system: {
        certificate_type: `${ROOTS.DASHBOARD}/define/system/certificate-type`,
        address_type: `${ROOTS.DASHBOARD}/define/system/address-type`,
        root: `${ROOTS.DASHBOARD}/define/system`,
        academic_year: `${ROOTS.DASHBOARD}/define/system/academic-year`,
        semester: `${ROOTS.DASHBOARD}/define/system/semester`,
        shirt_size: `${ROOTS.DASHBOARD}/define/system/shirt-size`,
        grade: `${ROOTS.DASHBOARD}/define/system/grade`,
        gender: `${ROOTS.DASHBOARD}/define/system/gender`,
        meal_preference: `${ROOTS.DASHBOARD}/define/system/meal-preference`,
        competition_type: `${ROOTS.DASHBOARD}/define/system/competition-type`,
        age_interval: `${ROOTS.DASHBOARD}/define/system/age-interval`,
        project_file_type: `${ROOTS.DASHBOARD}/define/system/project-file-type`,
        language: `${ROOTS.DASHBOARD}/define/system/language`,
        document_format_type: `${ROOTS.DASHBOARD}/define/system/document-format-type`,
        document_type: `${ROOTS.DASHBOARD}/define/system/document-type`,
        email_type: `${ROOTS.DASHBOARD}/define/system/email-type`,
        phone_type: `${ROOTS.DASHBOARD}/define/system/phone-type`,
        role: `${ROOTS.DASHBOARD}/define/system/role`,
        visa_type: `${ROOTS.DASHBOARD}/define/system/visa-type`,
        disability_type: `${ROOTS.DASHBOARD}/define/system/disability-type`,
        transportation_type: `${ROOTS.DASHBOARD}/define/system/transportation-type`,
        feedback_type: `${ROOTS.DASHBOARD}/define/system/feedback-type`,
      },
      competition: {
        root: `${ROOTS.DASHBOARD}/define/competition`,
        competition_payment_type: `${ROOTS.DASHBOARD}/define/competition/competition-payment-type`,
        application_type: `${ROOTS.DASHBOARD}/define/competition/application-type`,
        project_participation_type: `${ROOTS.DASHBOARD}/define/competition/project-participation-type`,
        project_award_type: `${ROOTS.DASHBOARD}/define/competition/project-award-type`,
        consent_term: `${ROOTS.DASHBOARD}/define/competition/consent-term`,
        performance_type: `${ROOTS.DASHBOARD}/define/competition/performance-type`,
        venue: `${ROOTS.DASHBOARD}/define/competition/venue`,
      },
      judgement: {
        root: `${ROOTS.DASHBOARD}/define/judgement`,
        judgement_period: `${ROOTS.DASHBOARD}/define/judgement/judgement-period`,
        judgement_criterion: `${ROOTS.DASHBOARD}/define/judgement/judgement-criterion`,
        judgement_criterion_category: `${ROOTS.DASHBOARD}/define/judgement/judgement-criterion-category`,
      },
      recheck: {
        root: `${ROOTS.DASHBOARD}/define/recheck`,
        user_organization: `${ROOTS.DASHBOARD}/define/recheck/user-organization`,
        group_role_join: `${ROOTS.DASHBOARD}/define/recheck/group-role-join`,
        unknown_user: `${ROOTS.DASHBOARD}/define/recheck/unknown-user`,
      },
      geography: {
        root: `${ROOTS.DASHBOARD}/define/geography`,
        country: `${ROOTS.DASHBOARD}/define/geography/country`,
        region: `${ROOTS.DASHBOARD}/define/geography/region`,
        province: `${ROOTS.DASHBOARD}/define/geography/province`,
        district: `${ROOTS.DASHBOARD}/define/geography/district`,
        city: `${ROOTS.DASHBOARD}/define/geography/city`,
        continent: `${ROOTS.DASHBOARD}/define/geography/continent`,
      },
      authorization: {
        root: `${ROOTS.DASHBOARD}/define/authorization`,
        group_role: `${ROOTS.DASHBOARD}/define/authorization/group-role`,
        group_role_organization: `${ROOTS.DASHBOARD}/define/authorization/group-role-organization`,
        group_role_organization_module: `${ROOTS.DASHBOARD}/define/authorization/group-role-organization-module`,
        role_module_permission: `${ROOTS.DASHBOARD}/define/authorization/role-module-permission`,
        role: `${ROOTS.DASHBOARD}/define/authorization/role`,
      },
      permission: {
        root: `${ROOTS.DASHBOARD}/define/permission`,
        module: `${ROOTS.DASHBOARD}/define/permission/module`,
        permission: `${ROOTS.DASHBOARD}/define/permission/permission`,
        module_permission: `${ROOTS.DASHBOARD}/define/permission/module-permission`,
        page_guideline: `${ROOTS.DASHBOARD}/define/permission/page-guideline`,
        permission_role: `${ROOTS.DASHBOARD}/define/permission/permission-role`,
      },
      user_organization: {
        root: `${ROOTS.DASHBOARD}/define/user-organization`,
        user_organization: `${ROOTS.DASHBOARD}/define/user-organization/user-organization`,
        group_role_join: `${ROOTS.DASHBOARD}/define/user-organization/group-role-join`,
        unknown_user: `${ROOTS.DASHBOARD}/define/user-organization/unknown-user`,
      },
      discipline: {
        root: `${ROOTS.DASHBOARD}/define/discipline`,
        category: `${ROOTS.DASHBOARD}/define/discipline/category`,
        subject: `${ROOTS.DASHBOARD}/define/discipline/subject`,
        sub_discipline: `${ROOTS.DASHBOARD}/define/discipline/sub-discipline`,
        topic: `${ROOTS.DASHBOARD}/define/discipline/topic`,
        sub_topic: `${ROOTS.DASHBOARD}/define/discipline/sub-topic`,
      },
      company_insight: {
        root: `${ROOTS.DASHBOARD}/define/company-insight`,
        unit: `${ROOTS.DASHBOARD}/define/company-insight/unit`,
        department: `${ROOTS.DASHBOARD}/define/company-insight/department`,
        office: `${ROOTS.DASHBOARD}/define/company-insight/office`,
        group: `${ROOTS.DASHBOARD}/define/company-insight/group`,
      },
      accommodation: {
        root: `${ROOTS.DASHBOARD}/define/accommodation`,
        room_occupant_role: `${ROOTS.DASHBOARD}/define/accommodation/room-occupant-role`,
        room_type: `${ROOTS.DASHBOARD}/define/accommodation/room-type`,
      },
      travel: {
        root: `${ROOTS.DASHBOARD}/define/travel`,
        terminal: `${ROOTS.DASHBOARD}/define/travel/terminal`,
        transport_location: `${ROOTS.DASHBOARD}/define/travel/transport-location`,
        transport_company: `${ROOTS.DASHBOARD}/define/travel/transport-company`,
      },
      schedule: {
        root: `${ROOTS.DASHBOARD}/define/schedule`,
        schedule_event: `${ROOTS.DASHBOARD}/define/schedule/schedule-event`,
        schedule_event_category: `${ROOTS.DASHBOARD}/define/schedule/schedule-event-category`,
      },
    },
    // süper define
    super_define: {
      root: `${ROOTS.DASHBOARD}/super-define`,
      organization: {
        root: `${ROOTS.DASHBOARD}/super-define/organization`,
        organization_type: `${ROOTS.DASHBOARD}/super-define/organization/organization-type`,
        organization_sub_type: `${ROOTS.DASHBOARD}/super-define/organization/organization-sub-type`,
      },
    },
    schedule: {
      root: `${ROOTS.DASHBOARD}/schedule`,
    },
    documents: {
      root: `${ROOTS.DASHBOARD}/documents`,
      new: `${ROOTS.DASHBOARD}/documents/new`,
    },
    profile: {
      root: `${ROOTS.DASHBOARD}/profile`,
      view: (id) => `${ROOTS.DASHBOARD}/profile/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/profile/edit/${id}`,
    },
    competition: {
      root: `${ROOTS.DASHBOARD}/competition`,
      new: `${ROOTS.DASHBOARD}/competition/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/competition/edit/${id}`,
      details: (id) => `${ROOTS.DASHBOARD}/competition/${id}`,
    },
    fair: {
      root: `${ROOTS.DASHBOARD}/fair`,
      edit: (id) => `${ROOTS.DASHBOARD}/fair/edit/${id}`,
      new: `${ROOTS.DASHBOARD}/fair/new`,
    },
    organization: {
      root: `${ROOTS.DASHBOARD}/organization`,
      edit: (id) => `${ROOTS.DASHBOARD}/organization/edit/${id}`,
      new: `${ROOTS.DASHBOARD}/organization/new`,
    },
    projects: {
      root: `${ROOTS.DASHBOARD}/projects`,
      edit: (id) => `${ROOTS.DASHBOARD}/projects/edit/${id}`,
      new: `${ROOTS.DASHBOARD}/projects/new`,
      detail: (id) => `${ROOTS.DASHBOARD}/projects/detail/${id}`,
      consent: (id) => `${ROOTS.DASHBOARD}/projects/consent/${id}`,
    },

    participation: {
      root: `${ROOTS.DASHBOARD}/participation`,
      participant: {
        root: `${ROOTS.DASHBOARD}/participation/participant`,
        new: `${ROOTS.DASHBOARD}/participation/participant/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/participation/participant/edit/${id}`,
      },
      vip: {
        root: `${ROOTS.DASHBOARD}/participation/vip`,
        new: `${ROOTS.DASHBOARD}/participation/vip/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/participation/vip/edit/${id}`,
      },
      finalist: {
        root: `${ROOTS.DASHBOARD}/participation/finalist`,
        edit: (id) => `${ROOTS.DASHBOARD}/participation/finalist/edit/${id}`,
      },
      invitation_letter: `${ROOTS.DASHBOARD}/participation/invitation-letter`,
    },
    // Printable
    printable: {
      root: `${ROOTS.DASHBOARD}/printable`,
      participant_badge: {
        root: `${ROOTS.DASHBOARD}/printable/participant-badge`,
      },
      consent_form: {
        root: `${ROOTS.DASHBOARD}/printable/consent-form`,
      },
    },
    // Certificate
    certificate: {
      root: `${ROOTS.DASHBOARD}/certificate`,
      participant_certificate: {
        root: `${ROOTS.DASHBOARD}/certificate/participant-certificate`,
      },
      project_award: {
        root: `${ROOTS.DASHBOARD}/certificate/project-award`,
      },
    },
    trip: {
      root: `${ROOTS.DASHBOARD}/trip`,
      tour: {
        root: `${ROOTS.DASHBOARD}/trip/tour`,
        new: `${ROOTS.DASHBOARD}/trip/tour/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/trip/tour/edit/${id}`,
      },
      tourReservation: {
        root: `${ROOTS.DASHBOARD}/trip/tour-reservation`,
        new: `${ROOTS.DASHBOARD}/trip/tour-reservation/new`,
        edit: (id) => `${ROOTS.DASHBOARD}/trip/tour-reservation/edit/${id}`,
        details: (id) => `${ROOTS.DASHBOARD}/trip/tour-reservation/details/${id}`,
      },
    },
    payment: {
      root: `${ROOTS.DASHBOARD}/payment`,
      success: `${ROOTS.DASHBOARD}/payment/success`,
      failed: `${ROOTS.DASHBOARD}/payment/failed`,
    },
    judgement: {
      root: `${ROOTS.DASHBOARD}/judgement`,
      judging_session: `${ROOTS.DASHBOARD}/judgement/judging-session`,
      judging_session_new: `${ROOTS.DASHBOARD}/judgement/judging-session/new`,
      judging_session_edit: (id) => `${ROOTS.DASHBOARD}/judgement/judging-session/edit/${id}`,
      judging_session_assign_jury: (id) =>
        `${ROOTS.DASHBOARD}/judgement/judging-session/assign-jury/${id}`,
      judging_session_assign_project: (id) =>
        `${ROOTS.DASHBOARD}/judgement/judging-session/assign-project/${id}`,
      jury: {
        root: `${ROOTS.DASHBOARD}/judgement/jury`,
        edit: (id) => `${ROOTS.DASHBOARD}/judgement/jury/edit/${id}`,
      },
      judgement_evaluation: {
        root: `${ROOTS.DASHBOARD}/judgement/judgement-evaluation`,
        detail: (id) => `${ROOTS.DASHBOARD}/judgement/judgement-evaluation/detail/${id}`,
      },
      evaluation_overview: `${ROOTS.DASHBOARD}/judgement/overview`,
      ranking: `${ROOTS.DASHBOARD}/judgement/ranking`,
    },
    travel: {
      root: `${ROOTS.DASHBOARD}/travel`,
      new: `${ROOTS.DASHBOARD}/travel/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/travel/edit/${id}`,
    },
    performance: {
      root: `${ROOTS.DASHBOARD}/performance`,
      edit: (id) => `${ROOTS.DASHBOARD}/performance/edit/${id}`,
      new: `${ROOTS.DASHBOARD}/performance/new`,
    },

    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/edit/${id}`,
    },
    system: {
      root: `${ROOTS.DASHBOARD}/system`,
      logger: {
        root: `${ROOTS.DASHBOARD}/system/logger`,
      },
      feedback: {
        root: `${ROOTS.DASHBOARD}/system/feedback`,
      },
    },
  },
};
